import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { LaboratoryRequestIndicatorDto } from "../models/laboratory/laboratory-request-indicator.dto";
import { NotificationService } from "../../core/services/notification.service";
import { Observable } from "rxjs";
import { ActionDataResult } from "../models/core/ActionDataResult";
import { Injectable } from "@angular/core";
import { LaboratoryRequestIndicatorListItem } from "../models/laboratory/laboratory-request-indicator-list-item";
import { UpdateRequestIndicatorValueFromActivity } from "../models/laboratory/update-request-indicator-value-from-activity";
import { tap } from "rxjs/operators";

@Injectable()
export class LaboratoryRequestIndicatorsService extends DataService<LaboratoryRequestIndicatorListItem, LaboratoryRequestIndicatorDto> {

    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'laboratory-request-indicators';
    }

    getAllByRequest(requestId: number): Observable<LaboratoryRequestIndicatorListItem[]> {
        return this.getQuery<LaboratoryRequestIndicatorListItem[]>(`${this.baseUrl()}/by-request/${requestId}`)
        .pipe(tap(resp => {
            resp.forEach(x => this.setIndicatorStringValue(x));
        }));
    }

    getAllByRequestActivities(requestId: number): Observable<LaboratoryRequestIndicatorListItem[]> {
        return this.getQuery<LaboratoryRequestIndicatorListItem[]>(`${this.baseUrl()}/by-request-activities/${requestId}`)
        .pipe(tap(resp => {
            resp.forEach(x => this.setIndicatorStringValue(x));
        }));
    }

    changeValueFromActivity(model: UpdateRequestIndicatorValueFromActivity): Observable<any> {
        return this.putQuery(`${this.baseUrl()}/change-value-from-activity`, model);
    }

    updateComment(model: { laboratoryRequestIndicatorId: number; comment: string }): Observable<any> {
        return this.putQuery(`${this.baseUrl()}/update-comment`, model);
    }

    private setIndicatorStringValue(dataItem: LaboratoryRequestIndicatorListItem) {
        if (dataItem.value != null) {
            dataItem.stringValue = dataItem.value.toString();

            if (dataItem.accuracy != null) {
                var itemParts = dataItem.stringValue.split('.');
                var doubleLength = itemParts.length == 2 ? itemParts[1].length : 0;

                if (doubleLength < dataItem.accuracy) {
                    if (doubleLength == 0) {
                        dataItem.stringValue += '.';
                    }

                    dataItem.stringValue += '0'.repeat(dataItem.accuracy - doubleLength);
                }
            }
        }
        else {
            dataItem.stringValue = '';
        }
    }
}